import { MISSION_CHANGE_LOG_FIELD_LABEL } from '../constants';

const REWARD_LEVEL_FIELD_PATTERN =
  /^(rewardLevels?)(?:\[\d+\])?(?:\.(conditionValue|rewardValue|conditionText))?$/;

const padLevelPosition = (position: number) =>
  String(position).padStart(2, '0');

const parseRewardLevelField = (field: string) => {
  const match = field.match(REWARD_LEVEL_FIELD_PATTERN);
  if (!match) return null;

  return {
    property: match[2],
  };
};

export const getMissionHistoryFieldLabel = (
  field: string,
  position?: number,
) => {
  const rewardLevelField = parseRewardLevelField(field);

  if (rewardLevelField) {
    const hasPosition = position !== undefined && position >= 1;
    const levelLabel = hasPosition ? ` ${padLevelPosition(position)}` : '';

    if (rewardLevelField.property === 'rewardValue') {
      return `Premiação${levelLabel}`.trim();
    }

    if (
      rewardLevelField.property === 'conditionValue' ||
      rewardLevelField.property === 'conditionText'
    ) {
      return `Objetivo${levelLabel}`.trim();
    }

    if (hasPosition) {
      return `Objetivo ${padLevelPosition(position)}`;
    }
  }

  return MISSION_CHANGE_LOG_FIELD_LABEL[field] ?? field;
};
